/**
 * ルーター
 *  各ページのURLを定義
 *  ログインのナビゲーションガードなども実装
 *  ないページはTopへリダイレクト（４０４ページに変更予定）
 */
// modules
import Vue    from 'vue'
import Router from 'vue-router'
import moment from 'moment'
// pages
import LP                 from '@/pages/LP'
import CaseStudy          from '@/pages/CaseStudy'
import Inquiry            from '@/pages/Inquiry'
import CompanyDemo        from '@/views/Top/CompanyDemo'
import PrivacyPolicy      from '@/pages/PrivacyPolicy'
import Terms              from '@/pages/Terms'
import Login              from '@/pages/Login'
import LoginResetRequest  from '@/pages/LoginResetRequest'
import MessageLogin       from '@/pages/MessageLogin'
import MessagePage        from '@/pages/MessagePage'
import CreateClient       from '@/pages/CreateClient'
import CreateUser         from '@/pages/CreateUser'
import ChatBotPage        from '@/pages/ChatBotPage'
import StoryPage          from '@/pages/StoryPage'
import ChatSinglePage     from '@/pages/ChatSinglePage'
import ChatSingleDemoPage from '@/pages/ChatSingleDemoPage'
import ImageDetailPage    from '@/pages/ImageDetailPage'
import PasswordReset      from '@/pages/PasswordReset'
import AddMember          from '@/pages/AddMember'
import Help               from '@/pages/Help'
import HelpInput          from '@/pages/HelpInput'
import CategoryHelp       from '@/pages/CategoryHelp'
import CategoryHelpInput  from '@/pages/CategoryHelpInput'
import Store              from '@/pages/Store'
import RecruitStory       from '@/pages/RecruitStory'
// ロボアイコン
import ChatWidgetDialog   from '@/views/ChatWidget/ChatWidgetDialog'
import ChatWidgetTimeline from '@/views/ChatWidget/ChatWidgetTimeline'

/* *
 *
 * ダッシュボードページ
 * views以下のBodyのみ遷移させる
 *
 * */
import DashBoard       from '@/pages/DashBoard'
import Home            from '@/views/DashBoard/Home/Home'
import EasyMaking      from '@/views/DashBoard/Tutorial/EasyMaking'
import DirectTalk      from '@/views/DashBoard/DirectTalk/DirectTalk'
import ScoutView       from '@/views/DashBoard/DirectTalk/ScoutView'
import ChatBotList     from '@/views/DashBoard/ChatBot/ChatBotList'
import ChatBot         from '@/views/DashBoard/ChatBot/ChatBot'
import PerformanceView from '@/views/DashBoard/Performance/PerformanceView'
import Manage          from '@/views/DashBoard/Manage/ManageMainView'
import Calendar        from '@/views/DashBoard/Calendar/Calendar'
import CalendarView    from '@/views/DashBoard/Calendar/CalendarView'
import Setting         from '@/views/DashBoard/Setting/Setting'
import EmploymentPage  from '@/views/DashBoard/EmploymentPage/EmploymentPage'
import VideoView       from '@/views/DashBoard/VideoView/VideoView'
import RecordView      from '@/views/DashBoard/VideoView/RecordView'
import MediaPool       from '@/views/DashBoard/MediaPool/MediaPool'
import Story           from '@/views/DashBoard/Story/Story'
import StoryList       from '@/views/DashBoard/Story/StoryList'
import StoryEdit       from '@/views/DashBoard/Story/StoryEdit'
import VirtualOffice   from '@/views/DashBoard/VirtualOffice/VirtualOffice'
/* *
 *
 * β版解析レポート
 *
 * */

import Report         from '@/views/DashBoard/Report/Report'

/* *
 *
 * ロボ関連ページ
 *
 * */
import RoboEmployment  from '@/views/DashBoard/Robo/RoboEmployment'
import RoboList        from '@/views/DashBoard/Robo/RoboList'

/* *
 *
 * 管理者ページ
 * HRM2nd season に向けた作り
 *
 * */
import Client         from '@/views/Client/Client'
import PasswordResetPeriodical from '@/views/PasswordReset/PasswordResetPeriodical'
import InitEasyMaking from '@/components2/Tutorial/EasyMaking'
/* *
 * Emailからのアクションページ
 * */
import EmailAction    from '@/views/Email/EmailAction'

/* *
 * Calendarからのアクションページ
 * */
import CalendarAction          from '@/views/Calendar/CalendarAction'
import EventFromScenarioAction from '@/views/Calendar/EventFromScenarioAction'
/* *
 *
 * User側ページ
 * 検索、プロフィール編集、チャットなど
 *
 * */
import MyPage         from '@/views/Recruit/MyPage'
import Status         from '@/views/Recruit/Status'
import FavoriteNovel  from '@/views/Recruit/FavoriteNovel'
import FollowCompany  from '@/views/Recruit/FollowCompany'
import Withdrawal     from '@/views/Recruit/Withdrawal'
/* *
 *
 * ウェブ会議
 *
 * */
import VideoInterview        from '@/views/VideoInterview/VideoInterview'
import RequestVideoInterview from '@/views/VideoInterview/RequestVideoInterview'
import RecordInterview       from '@/views/VideoInterview/RecordInterview'
/* *
 *
 * 求人LP用ロボフォーム
 *
 * */
import ChatBotForm  from '@/views/RecruitLP/ChatBotForm'
/* *
 *
 * 採用ページ
 *
 * */
import EmploymentPageList   from '@/views/DashBoard/EmploymentPage/EmploymentPageList'
import EmploymentPageEditor from '@/views/DashBoard/EmploymentPage/EmploymentPageEditor'
import EmploymentTemplate   from '@/views/DashBoard/EmploymentPage/EmploymentTemplate'
/* *
 *
 * 設定ページ
 * views以下のBodyのみ遷移させる
 *
 * */
import PersonalSetting  from '@/views/DashBoard/Setting/PersonalSetting'
import CompanySetting   from '@/views/DashBoard/Setting/CompanySetting'
import NotifySetting    from '@/views/DashBoard/Setting/NotifySetting'
import UserAdminSetting from '@/views/DashBoard/Setting/UserAdminSetting'
import CommonSetting    from '@/views/DashBoard/Setting/CommonSetting'
import AppIconSetting   from '@/views/DashBoard/Setting/AppIconSetting'
import BillingSetting   from '@/views/DashBoard/Setting/Billing/BillingSetting'
/* *
 *
 * スーパーユーザ(robottteユーザ)のみに公開
 *
 * */
import ControlLogView from '@/views/DashBoard/Operation/ControlLogView'
import RecruitmentMediaInfoSetting from '@/hrm-frontend/views/atomic/screen-components/operation-management/atomic-templates/RecruitmentMediaInfoSetting'
/* *
 *
 * 資料請求ページ
 *
 * */
import Download from '@/views/Download/Download'
/* *
 *
 * 404ページ
 *
 * */
import NotFound from '@/views/NotFound/404'
/* *
 *
 * 共通で持ってくための状態管理
 *
 * */
import store from '@/store'
Vue.use(Router)

const requireAuthenticated = (to, from, next) => {
  store.dispatch('auth/getAccountDetails')
    .then(() => {
      const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + store.getters['auth/getUser'].companyID + '/' + store.getters['auth/getUser'].userHash
      const user = store.getters['auth/getUser'];
      store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
        .then(() => {
          if (!store.getters['auth/isAuthenticated']) {
            next('/login')
          } else {
            if (store.getters['auth/isUser']) {
              next('/recruit/')
            } else {
              if (store.getters['auth/getUser'].version === 2 && to.fullPath.indexOf('/dashboard') === 0) {
                if (store.getters['auth/getUser'].is_tutorial && localStorage.getItem('_bfr_open') != new Date().getDate()) {
                  next('/client/tutorial')
                // パスワードリセットの条件分岐を追加
              } else if (store.getters['auth/getUser'].pass_notify_flag) {
                const passwordSetDate = new Date(store.getters['auth/getUser'].password_set_date);
                const passwordNotifyDate = new Date(store.getters['auth/getUser'].pass_notify_chg_date);
                const currentDate = new Date();
                const thirtyDaysInMilliseconds = 30 * 24 * 60 * 60 * 1000; // 30日のミリ秒
                const oneDayInMilliseconds = 24 * 60 * 60 * 1000; // 1日のミリ秒
                const daysSincePasswordSet = (currentDate - passwordSetDate) / oneDayInMilliseconds;
                const daysSincePasswordNotify = (currentDate - passwordNotifyDate) / oneDayInMilliseconds;
                const replacedPath = to.fullPath.replace('dashboard', 'client'); // 'dashboard'を'client'に置換
                // ケース1: ユーザーのパスワード変更日が、会社のパスワード通知設定日より30日超であり、かつ、ユーザーのログイン日現在は、変更日より30日未満
                if ((passwordNotifyDate - passwordSetDate) > thirtyDaysInMilliseconds && daysSincePasswordNotify < 30) {
                      if (replacedPath === '/client') {
                      next('/client/manage');
                    } else {
                      next(replacedPath);// そうでなければ、置換後のパスにリダイレクト
                    }
                // ケース2: ユーザーのパスワード変更日が、会社のパスワード通知設定日より30日超であり、かつ、ユーザーのログイン日現在は、変更日より30日を過ぎている
                  } else if ((passwordNotifyDate - passwordSetDate) > thirtyDaysInMilliseconds && daysSincePasswordNotify >= 30) {
                    if (replacedPath === '/client') {
                          next('/password/reset_periodical');
                        } else {
                          next(replacedPath);// そうでなければ、置換後のパスにリダイレクト
                        }
                    // ケース3: ユーザーのパスワード変更日が、会社のパスワード通知設定日より30日未満であり、かつ、会社のパスワード通知設定日よりユーザーのパスワード変更日は前であり、かつ、ユーザーのログイン日現在は、変更日より30日未満
                  } else if ((passwordNotifyDate - passwordSetDate) < thirtyDaysInMilliseconds && (passwordNotifyDate - passwordSetDate) >= 0 && daysSincePasswordSet < 30) {
                    if (replacedPath === '/client') {
                          next('/client/manage');
                        } else {
                          next(replacedPath);// そうでなければ、置換後のパスにリダイレクト
                        }
                    // ケース4: ユーザーのパスワード変更日が、会社のパスワード通知設定日より30日未満であり、かつ、会社のパスワード通知設定日よりユーザーのパスワード変更日は前であり、かつ、ユーザーのログイン日現在は、変更日より30日を過ぎている
                  } else if ((passwordNotifyDate - passwordSetDate) < thirtyDaysInMilliseconds && (passwordNotifyDate - passwordSetDate) >= 0 && daysSincePasswordSet >= 30) {
                      if (replacedPath === '/client') {
                        next('/password/reset_periodical');
                      } else {
                        next(replacedPath);// そうでなければ、置換後のパスにリダイレクト
                      }
                    // ケース5: ユーザーのパスワード変更日が、会社のパスワード通知設定日以降であり、かつ、ユーザーのログイン日現在は、変更日より30日未満
                  } else if ((passwordNotifyDate - passwordSetDate) < 0 && daysSincePasswordSet < 30) {
                      if (replacedPath === '/client') {
                        next('/client/manage');
                      } else {
                        next(replacedPath);// そうでなければ、置換後のパスにリダイレクト
                      }
                    // ケース6: ユーザーのパスワード変更日が、会社のパスワード通知設定日以降であり、かつ、ユーザーのログイン日現在は、変更日より30日を過ぎている
                  } else if ((passwordNotifyDate - passwordSetDate) < 0 && daysSincePasswordSet >= 30) {
                    if (replacedPath === '/client') {
                        next('/password/reset_periodical');
                      } else {
                        next(replacedPath);// そうでなければ、置換後のパスにリダイレクト
                      }
                  } 
                } else if (to.fullPath === '/dashboard') {
                  next('/client/manage')
                } else {
                  next(to.fullPath.replace('dashboard', 'client'))
                }
              } else if (store.getters['auth/getUser'].version === 1 && to.fullPath.indexOf('/client') === 0) {
                next('/dashboard')
              } else if (store.getters['auth/getUser'].is_tutorial && to.fullPath.indexOf('/client/tutorial') === -1) {
                next('/client/tutorial')
              } else {
                next()
              }
            }
          }
        })
  })
}
const getAccountAuthenticated = (to, from, next) => {
  store.dispatch('auth/getAccountDetailsUser')
    .then(() => {
    if (!store.getters['auth/isAuthenticated']) {
      next('/login')
    } else {
      if (store.getters['auth/isUser']) {
        next()
      } else if (store.getters['auth/isClient']) {
        next('/dashboard')
      } else {
        next()
      }
    }
  })
}
const loginAuthenticated = (to, from, next) => {
  store.dispatch('auth/getAccountDetails')
    .then(() => {
      if (store.getters['auth/isAuthenticated'] && store.getters['auth/isClient']) {
        if (store.getters['auth/getUser'].version === 2) {
          if (store.getters['auth/getUser'].is_tutorial) {
            next('/client/tutorial')
          } else { 
            next('/client/manage')
          }
        } else {
          next('/dashboard')
        }
      } else if (store.getters['auth/isAuthenticated'] && store.getters['auth/isUser']) {
        location.href = process.env.WDT_ENDPOINT + '/recruit/'
      } else if (store.getters['auth/isAuthenticated'] && store.getters['auth/getUser'].is_tutorial && to.fullPath.indexOf('/client/tutorial') === -1) {
        next('/client/tutorial')
      } else {
        next()
      }
    })
    .catch(error => {
      console.error("Error in getAccountDetails:", error);
    });
}
const demoRoboAuth = (to, from, next) => {
  store.dispatch('auth/getAccountDetails')
    .then(() => {
      next()
  })
}
const webInterviewAuth = (to, from, next) => {
  store.dispatch('auth/getAccountDetailsUser')
    .then(() => {
    if (!store.getters['auth/isAuthenticated'] || !store.getters['auth/isClient']) {
      next('/videointerview/access/' + to.params.room_name + '/' + to.params.my_name)
    } else {
      next()
    }
  })
}
const requireSuperUser = (to, from, next) => {
  if (store.getters['auth/isAgent']) next()
  else next('/404')
}


const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: NotFound
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '/',
      name: 'LP',
      component: LP
    },
    {
      path: '/case_study/:company_name',
      name: 'CaseStudy',
      component: CaseStudy
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/privacy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/inquiry',
      name: 'Inquiry',
      component: Inquiry
    },
    {
      path: '/companydemo',
      name: 'CompanyDemo',
      component: CompanyDemo
    },
    {
      path: '/dl',
      name: 'Download',
      component: Download
    },
    {
      path: '/chat',
      name: 'ChatWidgetDialog',
      component: ChatWidgetDialog
    },
    {
      path: '/timeline',
      name: 'ChatWidgetTimeline',
      component: ChatWidgetTimeline
    },
    {
      path: '/single/demo/:companyid/:scnName',
      name: 'ChatSingleDemoPage',
      component: ChatSingleDemoPage,
      beforeEnter: demoRoboAuth
    },
    {
      path: '/single/demo/:companyid/:scnName/:minipk',
      name: 'ChatSingleDemoPage',
      component: ChatSingleDemoPage,
      beforeEnter: demoRoboAuth
    },
    {
      path: '/image/:imageUrl',
      name: 'ImageDetailPage',
      component: ImageDetailPage,
    },
    {
      path: '/single/:companyid/:botid',
      name: 'ChatSinglePage',
      component: ChatSinglePage
    },
    {
      path: '/single/:companyid/:botid/:minipk',
      name: 'ChatSinglePage',
      component: ChatSinglePage
    },
    {
      path: '/recruits/bot/:companyid/:botid',
      name: 'ChatBotPage',
      component: ChatBotPage
    },
    {
      path: '/recruits/bot/:companyid/:botid/:minipk',
      name: 'ChatBotPage',
      component: ChatBotPage
    },
    {
      path: '/recruits/story/:companyid/:storyid',
      name: 'StoryPage',
      component: StoryPage
    },
    {
      path: '/recruits/lp_robo/:companyid/:contentsid',
      name: 'ChatBotForm',
      component: ChatBotForm
    },
    {
      path: '/recruits/recording_interview/:companyid/:id',
      name: 'RecordInterview',
      component: RecordInterview
    },
    {
      path: '/email_action',
      name: 'EmailAction',
      component: EmailAction
    },
    {
      path: '/calendar_action',
      name: 'CalendarAction',
      component: CalendarAction
    },
    {
      path: '/event_action/:id',
      name: 'EventFromScenarioAction',
      component: EventFromScenarioAction
    },
    {
      path: '/recruits/status/:companyid',
      name: 'Status',
      component: Status,
      beforeEnter: getAccountAuthenticated
    },
    {
      path: '/recruits/mypage/',
      name: 'MyPage',
      component: MyPage,
      beforeEnter: getAccountAuthenticated
    },
    {
      path: '/recruits/story',
      name: 'RecruitStory',
      component: RecruitStory,
      children: [
        {path: '',          component: StoryList},
      ],
      beforeEnter: getAccountAuthenticated
    },
    {
      path: '/recruits/storyedit/:id',
      name: 'StoryEdit',
      component: StoryEdit,
      beforeEnter: getAccountAuthenticated
    },
    {
      path: '/recruits/favoriteNovel/',
      name: 'FavoriteNovel',
      component: FavoriteNovel,
      beforeEnter: getAccountAuthenticated
    },
    {
      path: '/recruits/follow_company',
      name: 'FollowCompany',
      component: FollowCompany,
      beforeEnter: getAccountAuthenticated
    },
    {
      path: '/recruits/withdrawal/',
      name: 'Withdrawal',
      component: Withdrawal,
      beforeEnter: getAccountAuthenticated
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: loginAuthenticated
    },
    {
      path: '/login_reset_request/:user_id',
      name: 'LoginResetRequest',
      component: LoginResetRequest,
      props: true
    },
    {
      path: '/message_login/:seeker_id',
      name: 'MessageLogin',
      component: MessageLogin,
      props: true
    },
    {
      path: '/message_page/:seeker_id',
      name: 'MessagePage',
      component: MessagePage,
      props: true
    },
    {
      path: '/create_client',
      name: 'CreateClient',
      component: CreateClient
    },
    {
      path: '/create_user',
      name: 'CreateUser',
      component: CreateUser
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
    },
    {
      path:'/help/input',
      name: 'HelpInput',
      component: HelpInput,
    },
    {
      path: '/help/category',
      name: 'CategoryHelp',
      component: CategoryHelp,
    },
    {
      path:'/help/category/input',
      name: 'CategoryHelpInput',
      component: CategoryHelpInput,
    },
    {
      path: '/password/reset_page/:uuid',
      name: 'PasswordReset',
      component: PasswordReset
    },
    // 定期パスワード変更用画面
    {
      path: '/password/reset_periodical',
      name: 'PasswordResetPeriodical',
      component: PasswordResetPeriodical
    },
    {
      path: '/password/create/:uuid',
      name: 'AddMember',
      component: AddMember
    },
    {
      path: '/store',
      component: Store,
      beforeEnter: requireAuthenticated
    },
    {
      path: '/dashboard',
      name: 'DashBoard',
      component: DashBoard,
      children: [
        { path: '',             component: Home },
        { path: 'directtalk',   component: DirectTalk },
        { path: 'directtalk/scout', component: ScoutView },
        { path: 'chatbot',      component: ChatBotList },
        { path: 'story',        component: Story,
          children: [
            {path: '',          component: StoryList},
            {path: 'edit/:id',  component: StoryEdit},
          ]
        },
        { path: 'videoview',  component: VideoView },
        { path: 'manage',     component: Manage },
        { path: 'calendar',   component: Calendar},
        { path: 'mediapool',  component: MediaPool},
        { path: 'setting',    component: Setting,
          children: [
            {path: 'personal',  component: PersonalSetting},
            {path: 'common',    component: CommonSetting},
            {path: 'app_icon',  component: AppIconSetting},
            {path: 'other_api', component: NotifySetting},
            {path: 'user_list', component: UserAdminSetting},
            {path: 'company',   component: CompanySetting},
            {path: 'billing',   component: BillingSetting},
          ]
        },
        { path: 'employment', component: EmploymentPage,
          children: [
            {path: 'list', component: EmploymentPageList},
            {path: 'editor/:content_id', component: EmploymentPageEditor},
            {path: 'template', component: EmploymentTemplate},
          ]
        },
        // 解析レポート
        { path: 'report',  component: Report },
      ],
      beforeEnter: requireAuthenticated
    },
    // HRM 2nd 新画面
    {
      path: '/client',
      name: 'Client',
      component: Client,
      children: [
        { path: 'dashboard',        component: Home },
        { path: 'directtalk',       component: DirectTalk },
        { path: 'directtalk/scout', component: ScoutView },
        { path: 'chatbot',          component: ChatBot },
        { path: 'robo_employment',  component: RoboEmployment },
        { path: 'robo_list',        component: RoboList },
        { path: 'performance',      component: PerformanceView },
        { path: 'story',            component: Story,
          children: [
            {path: '',          component: StoryList},
            {path: 'edit/:id',  component: StoryEdit},
          ]
        },
        { path: 'videoview',  component: VideoView },
        { path: 'recordview', component: RecordView },
        { path: 'manage',     component: Manage },
        { path: 'calendar',   component: CalendarView,
          children: [
            {path: 'task',  component: CalendarView},
          ]
        },
        { path: 'mediapool',  component: MediaPool},
        { path: 'setting',    component: Setting,
          children: [
            {path: 'personal',  component: PersonalSetting},
            {path: 'common',    component: CommonSetting},
            {path: 'app_icon',  component: AppIconSetting},
            {path: 'other_api', component: NotifySetting},
            {path: 'user_list', component: UserAdminSetting},
            {path: 'company',   component: CompanySetting},
            {path: 'billing',   component: BillingSetting},
          ]
        },
        { path: 'employment', component: EmploymentPage,
          children: [
            {path: 'list', component: EmploymentPageList},
            {path: 'editor/:content_id', component: EmploymentPageEditor},
            {path: 'template', component: EmploymentTemplate},
          ]
        },
        { path: 'virtualoffice',  component: VirtualOffice},
        { path: 'operation/controllog', component: ControlLogView, beforeEnter: requireSuperUser},
        { path: 'operation/recruitment_media', component: RecruitmentMediaInfoSetting, beforeEnter: requireSuperUser},
        // チュートリアル用
        { path: 'tutorial',  component: InitEasyMaking},
        // Report
        { path: 'report',  component: Report,
          children: [
            {path: 'report',  component: Report},
          ]
        },
      ],
      beforeEnter: requireAuthenticated
    },
    // ウェブ会議
    {
      path: '/videointerview/:room_name/:my_name/',
      name: 'VideoInterview',
      component: VideoInterview,
      beforeEnter: webInterviewAuth
    },
    {
      path: '/videointerview/access/:room_name/:my_name/',
      name: 'RequestVideoInterview',
      component: RequestVideoInterview
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js